export const isDebug = (): boolean => import.meta.env.VITE_DEBUG === 'true';
export const apiRoute = (uri?: string): string => {
  if (!uri) {
    return '';
  }

  const base = import.meta.env.VITE_API_HOST;

  return `${base}/${uri.replace(/^\//, '')}`;
};
